/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { CreateTransactionFromReceiptMutationRequest, CreateTransactionFromReceiptMutationResponse, CreateTransactionFromReceiptPathParams, CreateTransactionFromReceipt400, CreateTransactionFromReceipt401, CreateTransactionFromReceipt403, CreateTransactionFromReceipt404, CreateTransactionFromReceipt409, CreateTransactionFromReceipt500 } from "../../types/financialHubController/CreateTransactionFromReceipt.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getCreateTransactionFromReceiptUrl(organizationId: CreateTransactionFromReceiptPathParams["organizationId"]) {
  const res = { method: 'POST', url: `/api/organizations/${organizationId}/financial/transactions/from-receipt` as const }
  return res
}

/**
 * @summary Create an UNREVIEWED manual entry from an OCR'd receipt and attach the document
 * {@link /api/organizations/:organizationId/financial/transactions/from-receipt}
 */
export async function createTransactionFromReceipt(organizationId: CreateTransactionFromReceiptPathParams["organizationId"], data: CreateTransactionFromReceiptMutationRequest, config: Partial<RequestConfig<CreateTransactionFromReceiptMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateTransactionFromReceiptMutationResponse, ResponseErrorConfig<CreateTransactionFromReceipt400 | CreateTransactionFromReceipt401 | CreateTransactionFromReceipt403 | CreateTransactionFromReceipt404 | CreateTransactionFromReceipt409 | CreateTransactionFromReceipt500>, CreateTransactionFromReceiptMutationRequest>({ method : "POST", url : getCreateTransactionFromReceiptUrl(organizationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}